export type AppRoute = "catalog" | "cart" | "orders" | "category" | "product" | "payment" | "order";

export type RouteState = {
  route: AppRoute;
  category: string;
  orderCode: string;
  productId: string;
};

export function routeFromPathname(pathname: string): AppRoute {
  if (pathname.startsWith("/categories/")) {
    return "category";
  }

  if (pathname.startsWith("/products/")) {
    return "product";
  }

  if (pathname.startsWith("/pay/")) {
    return "payment";
  }

  if (pathname.startsWith("/orders/")) {
    return "order";
  }

  if (pathname.startsWith("/cart")) {
    return "cart";
  }

  if (pathname.startsWith("/orders")) {
    return "orders";
  }

  return "catalog";
}

export function categoryFromPathname(pathname: string) {
  if (!pathname.startsWith("/categories/")) {
    return "";
  }

  return decodeURIComponent(pathname.replace("/categories/", ""));
}

export function orderCodeFromPathname(pathname: string) {
  if (pathname.startsWith("/pay/")) {
    return decodeURIComponent(pathname.replace("/pay/", ""));
  }

  if (pathname.startsWith("/orders/")) {
    return decodeURIComponent(pathname.replace("/orders/", ""));
  }

  return "";
}

export function productIdFromPathname(pathname: string) {
  if (!pathname.startsWith("/products/")) {
    return "";
  }

  return decodeURIComponent(pathname.replace("/products/", ""));
}

export function routeStateFromPathname(pathname: string): RouteState {
  return {
    route: routeFromPathname(pathname),
    category: categoryFromPathname(pathname),
    orderCode: orderCodeFromPathname(pathname),
    productId: productIdFromPathname(pathname),
  };
}

export function routeStateKey(routeState: RouteState) {
  if (routeState.route === "category") {
    return `category:${routeState.category}`;
  }

  if (routeState.route === "product") {
    return `product:${routeState.productId}`;
  }

  if (routeState.route === "payment" || routeState.route === "order") {
    return `${routeState.route}:${routeState.orderCode}`;
  }

  return routeState.route;
}

export function pathnameForRoute(route: AppRoute) {
  return route === "catalog" ? "/catalog" : `/${route}`;
}

export function pathnameForCategory(category: string) {
  return `/categories/${encodeURIComponent(category)}`;
}

export function pathnameForProduct(productId: string) {
  return `/products/${encodeURIComponent(productId)}`;
}

export function pathnameForPayment(orderCode: string) {
  return `/pay/${encodeURIComponent(orderCode)}`;
}

export function pathnameForOrder(orderCode: string) {
  return `/orders/${encodeURIComponent(orderCode)}`;
}
